import React, { FC } from 'react';
import { List } from 'antd';

import { Location } from '~/types';
import LocationCard from './LocationCard';
import { useDeepEffect, usePath, usePermissions } from '~/hooks';
import { locations } from '~/routes';
import { usePageShow } from '~/hooks/usePageQuery';

interface Props {
  data: Location[] | undefined;
  total: number;
  loading: boolean;
}

const CardsList: FC<Props> = (props) => {
  const { data, loading, total } = props;
  const { pagination, changePath } = usePath();
  const { showOpen } = usePageShow(locations);

  const pageSize = 5;
  useDeepEffect(() => {
    changePath({ page: 1, perPage: pageSize });
  }, [pageSize]);

  const hasAccessView = usePermissions('business.location.view');
  if (!hasAccessView) return null;
  return (
    <List
      grid={{ gutter, column }}
      dataSource={data}
      loading={loading}
      pagination={{
        pageSize,
        ...pagination,
        total,
      }}
      renderItem={(item) => (
        <List.Item key={item.id}>
          <LocationCard record={item} onClick={() => item.id && showOpen(item.id)} />
        </List.Item>
      )}
    />
  );
};

const column = 1;
const gutter = 24;

export default CardsList;
